<div class="row">
    <div class="col-md-4">
        <h4>Rent:</h4>
        <div class="row">
            <div class="col-md-4">
                <label>Lease #:</label>
            </div>
            <div class="col-md-8">
                {{data?.leaseNumber}}
            </div>
        </div>
        <div class="row">
            <div class="col-md-4">
                <label>Lease Rate:</label>
            </div>
            <div class="col-md-8">
                {{data?.leaseRate?.rate | currency}}
            </div>
        </div>
        <div class="row">
            <div class="col-md-4">
                <label>Customer:</label>
            </div>
            <div class="col-md-8">
                {{data?.customer?.name}}
            </div>
        </div>
        <br>		
        <h4>Base Rental:</h4>
        <div class="row">
            <div class="col-md-4">
                <label>{{data?.prorateMonth}} Prorate:</label>
            </div>
            <div class="col-md-8">
                {{data?.prorateAmount | currency}}
            </div>
        </div>
        <div class="row">
            <div class="col-md-4">
                <label>Calculation:</label>
            </div>
            <div class="col-md-8">
                {{data?.prorateCalculationUsed}}
            </div>
        </div>
        <div class="row" *ngFor="let billing of data.rent">
            <div class="col-md-4">
                <label>{{billing.item1}} Rent:</label>
            </div>
            <div class="col-md-8">
                {{billing.item2 | currency}}
            </div>
        </div>
        <br>
        <h4>Approval of this notification will:</h4>
        <div class="row">
            <div class="col-md-12">
                <ul>
                    <li>Update railcar status to <b>Active</b></li>
                    <li>Set CP date on lease to <b>{{data.arrivalDate | date: 'MM-dd-yyyy'}}</b></li>
                </ul>
            </div>
        </div>
    </div>
    <div class="col-md-8">
        <notification-trace-results 
            [(traceResults)] = "data.traceResults"
            [nightMode]="nightMode">
        </notification-trace-results>
        <div class="row" style="padding-top: 30px;">
            <div class="col-md-12">
                <div style="width: 125px;">
                    <kendo-datepicker *ngIf="!!data"
                        [(ngModel)]="data.arrivalDate"
                        [ngClass]="{'night-mode': nightMode}"
                        class="service-event-date-sm"
                        formatPlaceholder="short"
                        (valueChange)="dateChanged()"></kendo-datepicker>
                    <label class="service-event-date-label" style="font-weight: bold;">Arrival Date</label>
                </div>
            </div>
        </div>
    </div>
</div>
